import { FormApi } from 'final-form';
import React, { Fragment, useContext, useState } from 'react';
import { AlertBox, LocaleContext } from 'shared';
import { LoginPayload } from 'store/api/types';

import { Link } from './Registration.styles';
import { RegistrationProps } from './Registration.types';
import { RegistrationForm } from './registrationForm/RegistrationForm';

export const Registration = ({ onCreateUser, location, history, ...rest }: RegistrationProps) => {
  const [isSubmitFailed, setSubmitFailed] = useState(false);
  const [failMessage, setFailMessage] = useState('');
  const [isRegisterSuccess, setRegisterSuccess] = useState(false);
  const localeContext = useContext(LocaleContext);

  const handleSubmit = async (values: LoginPayload, formApi: FormApi) => {
    try {
      return await onCreateUser(values, formApi, () => {
        setRegisterSuccess(true);
      });
    } catch (error) {
      if (error.payload && error.payload.response && error.payload.response.message) {
        setFailMessage(error.payload.response.message);
      }

      setSubmitFailed(true);
    }
  };

  const handleResetFail = () => {
    setSubmitFailed(false);
    setFailMessage('');
  };

  return (
    <Fragment>
      {!isRegisterSuccess && !isSubmitFailed && <RegistrationForm {...rest} onSubmit={handleSubmit} />}

      {isRegisterSuccess && (
        <AlertBox
          type={AlertBox.types.SUCCESS}
          title={localeContext.formatMessage({ id: 'REGISTRATION.SUCCESS.TITLE' })}
        >
          {localeContext.formatMessage({ id: 'REGISTRATION.SUCCESS.CONTENT' })}
        </AlertBox>
      )}

      {isSubmitFailed && (
        <AlertBox type={AlertBox.types.FAIL} title={localeContext.formatMessage({ id: 'REGISTRATION.FAIL.TITLE' })}>
          {!failMessage && localeContext.formatMessage({ id: 'REGISTRATION.FAIL.CONTENT' })}

          {!!failMessage && (
            <span>
              <br />
              {failMessage}
            </span>
          )}

          <br />
          <br />
          <Link href="#" onClick={handleResetFail}>
            {localeContext.formatMessage({ id: 'REGISTRATION.FAIL.GO-BACK' })}
          </Link>
        </AlertBox>
      )}
    </Fragment>
  );
};
